import { Icon } from "@fluentui/react";
import React from "react";

const SettingTab = (props) => {

  const handleClick =(e) => {
    console.log("Hellooww world",e)
    if(props.tabName=="FAQ"){
      window.open("https://drive.google.com/file/d/1R5YrQcBlTHg9CZ5tNrQVATz0fPm9151x/view")
    }
    if(props.tabName=="Support"){
      window.open("mailto:support@deeptek.ai")
    }
    if(props.tabName=="Tutorial Video"){
      window.open("https://youtu.be/BNHN5Q6zDmY")
    }
}
    return (
        <div
        style={{
          padding: "10px",
          display: "flex",
          justifyContent: "space-between",
  
        }}
        onClick={handleClick.bind(this)}
      >
        <div style={{display:'flex', flexDirection:'column', margin: "0px 10px",justifyContent:'center'}}>
          <p
            style={{
              padding: "0px",
              fontSize: "16px",
              fontWeight: "600",
              textAlign: "start"
            }}
          >
           {props.tabName}
          </p>
          {props.subtitle != null && props != undefined &&<p
           className="tab-container-subtitle" style={{display:'flex'}}
          >{props.subtitle}</p>}
        </div>
      </div>
    )
}

export default SettingTab;